import * as THREE from 'three'
import { useRef, useEffect, useMemo } from 'react'
import { shaderMaterial, Center, Sparkles, useGLTF, useTexture,
         OrbitControls, useFBO } from '@react-three/drei'
import { useFrame, useThree, extend, useLoader } from '@react-three/fiber'
import Photos from './Photos.js'
import Projects from './Projects.js'
import Posters from './Posters.js'
import PostersScroll from './PostersScroll.js'
import Statement from './Statement.js'
import { useSelection } from './SelectionContext.js'
import useWindowWidth from './useWindowWidth';

export default function Experience()
{
    const { selection, setSelection } = useSelection()
    const isMobile = useWindowWidth();

    const renderContent = () => {
        switch(selection) {
          case 'photographs':
            return <Photos />
          case 'projects':
            return <Projects />
        case 'posters':
            return <PostersScroll />
          case 'statement':
            return <Statement isMobile={isMobile} />

          default:
            return <Statement isMobile={isMobile} />
        }
      }
      
      return (
        <>
          {renderContent()}
        </>
      )
    }